import { render, staticRenderFns } from "./HeaderFavorite.vue?vue&type=template&id=987af064&scoped=true"
import script from "./HeaderFavorite.vue?vue&type=script&lang=js"
export * from "./HeaderFavorite.vue?vue&type=script&lang=js"
import style0 from "./HeaderFavorite.vue?vue&type=style&index=0&id=987af064&lang=sass"
import style1 from "./HeaderFavorite.vue?vue&type=style&index=1&id=987af064&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987af064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987af064')) {
      api.createRecord('987af064', component.options)
    } else {
      api.reload('987af064', component.options)
    }
    module.hot.accept("./HeaderFavorite.vue?vue&type=template&id=987af064&scoped=true", function () {
      api.rerender('987af064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/HeaderFavorite.vue"
export default component.exports